import Api from '@/api/config.ts';
import { apiUrls } from '@/api/api-urls.ts';
import {
  Balance,
  IGetChallengesResponse,
  IGetTransactionsResponse,
  ITonTransaction,
  PayoutRequest
} from '@/api/ton/types.ts';

const getBalance = async (): Promise<Balance> => {
  const response = await Api.get<Balance>(apiUrls.ton.balance);

  return response.data;
};

const getChallenges = async (
  limit = 25,
  nextPageToken?: string
): Promise<IGetChallengesResponse> => {
  const response = await Api.get<IGetChallengesResponse>(
    apiUrls.ton.challenges,
    {
      params: {
        page_size: limit,
        ...(nextPageToken ? { page_token: nextPageToken } : {})
      }
    }
  );

  return response.data;
};

const getTransactions = async (
  limit = 25,
  nextPageToken?: string
): Promise<IGetTransactionsResponse> => {
  const response = await Api.get<IGetTransactionsResponse>(
    apiUrls.ton.transactions,
    {
      params: {
        page_size: limit,
        ...(nextPageToken ? { page_token: nextPageToken } : {})
      }
    }
  );

  return response.data;
};

const claimReward = async (challengeId: string) => {
  const response = await Api.post<unknown>(
    apiUrls.ton.claimReward(challengeId)
  );

  return response.data;
};

const requestPayout = async (payload: PayoutRequest) => {
  const response = await Api.post<{ transaction: ITonTransaction }>(
    apiUrls.ton.payout,
    payload
  );

  return response.data;
};

const TonController = {
  getBalance,
  getChallenges,
  getTransactions,
  claimReward,
  requestPayout
};

export default TonController;
